
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _400m6JOelMykXEXj_45fg3oolyHsr61jCG8x6Esn9rZA81ScMeta } from "/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/400.vue?macro=true";
import { default as _500Eb9U1BtgQNZ16iF9TwVdSwkZQ6CjkN8PIB8rqZdQUUcMeta } from "/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/500.vue?macro=true";
import { default as infoVl5ULINojaB69EATCBylh4DskNrCfbLtpuIJykbjb4kMeta } from "/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/info.vue?macro=true";
import { default as indexa1d2SVzdbDcZLigqS_XtnTGf_45Atrzvhrhvss2p1p_b8Meta } from "/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/index.vue?macro=true";
import { default as contatotoZU_4551Vt4xtAOyILv5XypZC92al3fon2GcIujXEKnoMeta } from "/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/contato.vue?macro=true";
import { default as empresawE020Ixo1Dzgimk9P9GvKMmefXBnuiebEdvxWUEym1cMeta } from "/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/empresa.vue?macro=true";
import { default as digiol3RR7mUcFbgKL1IyMuGygkKfCcCJaHyascGyJlvY_45DYMeta } from "/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/credor/digio.vue?macro=true";
import { default as redirecionarAr3Ku_WGFBTMgh98Dt8JUMYqicXIs_pVrzkSSp6549UMeta } from "/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/redirecionar.vue?macro=true";
import { default as pontofrio_d4T5WtR3gWqKH_45yjkYQno_4oezuAtMEyOi98hN4ZLEMeta } from "/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/credor/pontofrio.vue?macro=true";
import { default as casas_45bahiabP7p3zSKIKGQcm18r_nXd7AQn1kXL51sv01wWNXfEkcMeta } from "/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/credor/casas-bahia.vue?macro=true";
export default [
  {
    name: "400",
    path: "/400",
    component: () => import("/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/400.vue")
  },
  {
    name: "500",
    path: "/500",
    component: () => import("/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/500.vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/info.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexa1d2SVzdbDcZLigqS_XtnTGf_45Atrzvhrhvss2p1p_b8Meta || {},
    component: () => import("/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/index.vue")
  },
  {
    name: "contato",
    path: "/contato",
    component: () => import("/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/contato.vue")
  },
  {
    name: "empresa",
    path: "/empresa",
    component: () => import("/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/empresa.vue")
  },
  {
    name: "credor-digio",
    path: "/credor/digio",
    meta: digiol3RR7mUcFbgKL1IyMuGygkKfCcCJaHyascGyJlvY_45DYMeta || {},
    component: () => import("/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/credor/digio.vue")
  },
  {
    name: "redirecionar",
    path: "/redirecionar",
    component: () => import("/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/redirecionar.vue")
  },
  {
    name: "credor-pontofrio",
    path: "/credor/pontofrio",
    meta: pontofrio_d4T5WtR3gWqKH_45yjkYQno_4oezuAtMEyOi98hN4ZLEMeta || {},
    component: () => import("/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/credor/pontofrio.vue")
  },
  {
    name: "credor-casas-bahia",
    path: "/credor/casas-bahia",
    meta: casas_45bahiabP7p3zSKIKGQcm18r_nXd7AQn1kXL51sv01wWNXfEkcMeta || {},
    component: () => import("/codebuild/output/src3719381958/src/melembre-landing-page-v2/pages/credor/casas-bahia.vue")
  }
]